module.exports = __webpack_public_path__ + "img/32.a461ab7c.jpg";